/**
 * StatTile — a calm analytics tile: small label, big value, supporting note.
 * Used by owner-analysis. Brand tokens only.
 */
import type { ReactNode } from "react";

interface StatTileProps {
  label: string;
  value: ReactNode;
  note?: string;
  /** Brand tint for the value (defaults to genie-primary) */
  valueClassName?: string;
  className?: string;
}

export const StatTile = ({
  label,
  value,
  note,
  valueClassName = "text-genie-primary",
  className,
}: StatTileProps) => {
  return (
    <div
      className={`flex-1 rounded-[18px] border border-genie-border bg-white shadow-sm px-5 py-5 ${className ?? ""}`}
    >
      <p className="text-xs font-medium text-gray-500">{label}</p>
      <p className={`text-[34px] font-extrabold tracking-[-1px] mt-1.5 ${valueClassName}`}>{value}</p>
      {note && <p className="text-xs text-gray-600 mt-1">{note}</p>}
    </div>
  );
};

export default StatTile;
